export default __webpack_public_path__ + "static/media/pricing_art_3.d6ed0971.png";